// extracted by mini-css-extract-plugin
export var cardContainer = "_ou-0";
export var cardHeader = "_ou-2";
export var collapsedState = "_ou-3";
export var dragHandle = "_ou-5";
export var dragHandleIcon = "_ou-6";
export var dragging = "_ou-1";
export var titleArea = "_ou-4";